/**
 * ListingDataContext — lightweight context that provides listing data
 * to NeighborhoodSpokeContent when the full Redux currentListingDetails
 * is unavailable (e.g., inside the FeedView where listings come
 * from byCoords search results rather than FetchListingWrapper).
 */
import { createContext, useContext } from 'react';

const ListingDataContext = createContext<Record<string, unknown> | null>(null);

export const useListingDataOverride = (): Record<string, unknown> | null => {
  return useContext(ListingDataContext);
};

type ListingDataProviderProps = {
  listing: Record<string, unknown>;
  children: React.ReactNode;
};

export const ListingDataProvider = ({ listing, children }: ListingDataProviderProps) => (
  <ListingDataContext.Provider value={listing}>{children}</ListingDataContext.Provider>
);
